module.exports = __webpack_public_path__ + "img/25.8c805d93.png";